import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SCAMP_API } from 'src/environments/environment';
import { AreaTecnica } from '../../../models/area.tecnica.model';
import { AccountService } from '../../../services/account.service';

@Injectable({ providedIn: 'root'})
export class AreaTecnicaService {

    constructor(private http: HttpClient, private account: AccountService) { }

    getAreasTecnicas(): Observable<AreaTecnica[]> {
        return this.http.get<AreaTecnica[]>(`${SCAMP_API.accountApiV1}/areas-tecnicas-cb`, {headers : this.account.composeHeaders()});
    }

    setOutraAreaTecnica(dado): Observable<any> {
        return this.http.post(`${SCAMP_API.accountApiV1}/outra-area-tecnica`, dado,  {headers : this.account.composeHeaders()});
    }

    isUniqueNomeAreaTecnica(nome: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/nome-areatecnica-is-unique`, {nome},
        {headers : this.account.composeHeaders()});
    }

    create(data: any) {
        return this.http.post(`${SCAMP_API.accountApiV1}/areatecnica`, data, {headers : this.account.composeHeaders()});
    }

    read(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/areatecnica/${id}`, {headers : this.account.composeHeaders()});
    }

    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/areatecnica/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/areatecnica/${id}`, {headers : this.account.composeHeaders()});
    }

    list(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/areastecnicas`, {headers : this.account.composeHeaders()});
    }
}
